<template>
  <section class="home-offer-list">
    <!-- Skeleton loader -->
    <v-container v-if="isLoading">
      <v-row justify="center">
        <v-col
          v-for="n in 2"
          :key="n"
          class="px-0"
          cols="12"
          md="6"
        >
          <v-card class="offers-list__loader mb-3 py-6 px-2">
            <div class="d-flex justify-left align-center">
              <!-- Avatar -->
              <v-skeleton-loader class="mr-2" type="avatar"/>

              <!-- Main -->
              <div class="d-flex flex-column">
                <v-skeleton-loader type="text"/>
                <v-skeleton-loader class="mb-2" width="200%" type="heading"/>
                <v-skeleton-loader class="mb-6" type="text"/>
                <v-row class="ml-0">
                  <v-skeleton-loader
                    v-for="n in 4"
                    :key="n"
                    class="mr-2 my-0"
                    height="30"
                    width="30"
                    type="image"
                  />
                </v-row>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <h2 v-if="!isLoading && !listHasOffers" class="home__title">
      Lo sentimos, no tenemos ofertas que mostrar en este momento.
    </h2>

    <v-container>
      <v-row class="justify-center">
        <template v-if="listHasOffers">
          <OfferCard
            v-for="(offer, index) in offers"
            :key="offer.id"
            :offer="offer"
            :index="index"
            :featured="show === 'featured'"
            @get-offers="getOffers"
          />
        </template>

        <!-- Tarjetas impares -->
        <v-col
          v-if="offers.length % 2 !== 0"
          cols="12"
          md="6"
        >
          <!-- Featured -->
          <v-card
            v-if="show === 'featured'"
            class="home-offer-list__odd-card home-offer-list__odd-card--featured"
            tile
          >
            <div class="home-offer-list__odd-text text-md-left mb-2 mb-md-0">¿Quieres que tu organización sea parte de las ofertas destacadas?</div>
            <v-btn :to="{name: 'Pricing'}" class="home-offer-list__odd-button">HAZ CLICK AQUÍ</v-btn>
          </v-card>

          <!-- Normal -->
          <v-card
            v-else
            class="home-offer-list__odd-card"
            tile
          >
            <div class="home-offer-list__odd-text text-md-left mb-2 mb-md-0">¿Quieres que tu organización sea parte de Trabajo Con Sentido?</div>
            <v-btn :to="{name: 'Pricing'}" class="home-offer-list__odd-button">HAZ CLICK AQUÍ</v-btn>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import OfferCard from "@/components/OfferCard";

export default {
    name: "HomeOfferList",

    components: {
        OfferCard,
    },

    props: {
        tags: null,
        filter: null,
        loading: {
            type: Boolean,
        },
        show: {
            // "all": Todas las ofertas | "featured": Solo ofertas destacadas | "normal": Solo ofertas normales
            type: String,
            default: "all",
        },
    },

    data() {
        return {
            isLoading: true,
            offerList: undefined,
            page: 1,
            pages: [],
            pageSize: this.count ? this.count : 1000, // TODO parametrizar
        };
    },

    computed: {
        ...mapGetters("offers", ["sortedOffers", "featuredOffers", "normalOffers"]),

        offers() {
            return this.show === "all"
                ? this.sortedOffers
                : this.show === "featured"
                    ? this.featuredOffers
                    : this.normalOffers;
        },
        paginationShow() {
            return this.pages.length > 1;
        },
        listHasOffers() {
            return this.offers && this.offers.length > 0;
        },
    },

    methods: {
        ...mapActions("offers", ["getOffers"]),
        ...mapMutations("offers", ["SET_OFFERS"]),
    },

    async created() {
        await this.getOffers(this.tags);
        this.isLoading = false;
    }
};
</script>
